/**
 * ProductTab Molecule Component
 * Product navigation tab (visual-only, no routing)
 */

import React from 'react';
import type { ProductTabBlok } from '@/types';

export interface ProductTabProps extends ProductTabBlok {
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
}

export const ProductTab: React.FC<ProductTabProps> = ({
  label,
  isActive = false,
  onClick,
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        px-4 py-2 md:px-6 md:py-3 text-sm md:text-base font-bold
        transition-all duration-200 whitespace-nowrap
        ${isActive
          ? 'text-primary border-b-2 border-primary'
          : 'text-gray-400 hover:text-white border-b-2 border-transparent'
        }
        ${className}
      `}
    >
      {label}
    </button>
  );
};

export default ProductTab;
